// Jquery Document Ready Function Start
$(document).ready(function() {


//     gsap.registerPlugin(ScrollTrigger);

// // Timeline for loader animation
// const loaderTimeline = gsap.timeline();
// loaderTimeline.to(".loader", {
//   delay: 2,
//   opacity: 0,
//   duration: 1,
//   ease: "power3.out"
// });

// // Scroll-triggered animations for reveal-scroll containers
// document.querySelectorAll(".reveal-scroll").forEach((container) => {
//   const image = container.querySelector("img");

//   const tl = gsap.timeline({
//     scrollTrigger: {
//       trigger: container,
//       start: "top bottom", // Adjust start point as needed
//       toggleActions: "restart none none reset"
//     }
//   });

//   tl.set(container, { autoAlpha: 1 });
//   tl.from(container, {
//     xPercent: 100,
//     duration: 1.5,
//     ease: "power2.out"
//   });
//   tl.from(image, {
//     xPercent: -100,
//     scale: 1.3,
//     duration: 1.5,
//     ease: "power2.out",
//     delay: -1.5
//   });
// });



    // Initialize WOW.Js Start
    var $bannerSlider = jQuery('.banner-slider__slides');
    var bannerImg1Classes = 'animate__animated animate__fadeInLeft animate__fadeInRight animated';
    var bannerImg2Classes = 'animate__animated animate__fadeInDown animated';
    var bannerRevealTimer;

    function resetBannerInfo($context) {
        clearTimeout(bannerRevealTimer);
        $context.find('.info .img1').css({ opacity: '0', visibility: 'hidden', animation: 'none' }).removeClass(bannerImg1Classes);
        $context.find('.info .img2').css({ opacity: '0', visibility: 'hidden', animation: 'none' }).removeClass(bannerImg2Classes);
    }

    function replayBannerAnimation($element, animationClasses) {
        if (!$element.length) {
            return;
        }

        $element.removeClass(animationClasses).css({ opacity: '0', visibility: 'hidden', animation: 'none' });
        $element[0].offsetWidth;
        $element.css({ opacity: '1', visibility: 'visible', animation: '' }).addClass(animationClasses);
    }

    function revealBannerInfo($slide) {
        var img1Animation = $slide.find('.contain-wrapper--left').length ? 'animate__fadeInLeft' : 'animate__fadeInRight';
        var $img1 = $slide.find('.info .img1');
        var $img2 = $slide.find('.info .img2');

        resetBannerInfo($bannerSlider);

        bannerRevealTimer = setTimeout(function() {
            replayBannerAnimation($img1, 'animate__animated ' + img1Animation);
            replayBannerAnimation($img2, 'animate__animated animate__fadeInDown');
        }, 30);
    }

    resetBannerInfo($bannerSlider);
    $bannerSlider
        .on('init', function(event, slick) {
            jQuery(slick.$slider).closest('.banner-slider').addClass('banner-slider--ready');
            revealBannerInfo(jQuery(slick.$slides.get(slick.currentSlide)));
        })
        .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            revealBannerInfo(jQuery(slick.$slides.get(nextSlide)));
        });

    $bannerSlider.slick({
        autoplay: true, 
        fade: true,
        arrows: true,
        dots: false,
        useCSS: false,
        autoplaySpeed: 5000,   
        prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 41"><path d="M20.3 40.8 0 20.5 20.3.2l.7.7L1.3 20.5 21 40.1z"></path></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 41"><path d="M0.7 0.2L21 20.5 0.7 40.8l-.7-.7L19.7 20.5 0 0.9z"></path></svg></button>',

    });
    new WOW().init();
    // Initialize WOW.Js End

// ===============================
// Tours Slider JS (FINAL)
// ===============================

    jQuery(document).ready(function ($) {

  // ---------- 1. Slick Init ----------
      const $slider = $('.cards-slider');

      $slider.slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        autoplay: true,
        infinite: true,
        dots: true,
        arrows: true,
        autoplaySpeed: 4000,
        prevArrow:
        '<button type="button" class="slick-prev"><img src="/wp-content/themes/blue-poppy/src/img/previous-arrow.png"></button>',
        nextArrow:
        '<button type="button" class="slick-next"><img src="/wp-content/themes/blue-poppy/src/img/next-arrow.png"></button>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
          }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
      }
  },
  {
        breakpoint: 580,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }
]
});

      $slider.on('click', '.category', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const clickedCategory = $(this).text().trim();

        const slidesToScroll = $slider.slick('slickGetOption', 'slidesToScroll');

    // Slick ke saare slides loop karo
        $slider.find('.slick-slide').each(function () {

          const slickIndex = $(this).data('slick-index');

      // Sirf REAL slides (clone nahi)
          if (slickIndex >= 0) {

        // Center card logic
        // Example (3 slides): index 1,4,7...
            if ((slickIndex + 1) % slidesToScroll === 2) {

              const centerCategory = $(this)
              .find('.category')
              .first()
              .text()
              .trim();

              if (centerCategory === clickedCategory) {

            // Center slide ko visible lane ke liye
                const goToIndex = slickIndex - 1;

                $slider.slick('slickGoTo', goToIndex);
            return false; // loop break
        }
    }
}
});
    });

  });

    // Tours Js End

    jQuery('.travel-items').on('beforeChange', function(event, slick, currentSlide) {
        ['bg-wrapper', 'traveller'].forEach(boxClass => {
            new WOW({
                boxClass: boxClass,         
                animateClass: 'animate__animated', 
                offset: 100,                
                mobile: true,               
                live: true                  
            }).init();
        });
    });
    
    jQuery('.travel-items').slick({
        autoplay: true, 
        fade: true,
        arrows: false,
        dots: true,
        useCSS: false,
        autoplaySpeed: 5000,   
        prevArrow: '<button type="button" class="slick-prev"><i class="bx bx-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="bx bx-chevron-right"></i></button>',
    });

});
// Jquery Document Ready Function End


// Header Js Start
document.addEventListener("DOMContentLoaded", function () {
    let navbar = document.querySelector(".navbar");
    let navLinks = document.querySelector(".nav-links");
    let menuOpenBtn = document.querySelector(".navbar .bx-menu");
    let menuCloseBtn = document.querySelector(".nav-links .bx-x");

    if (menuOpenBtn) {
        menuOpenBtn.onclick = function () {
            navLinks.style.left = "0";
        }
    }

    if (menuCloseBtn) {
        menuCloseBtn.onclick = function () {
            navLinks.style.left = "-100%";

            let subMenus = document.querySelectorAll(".sub-menu");
            subMenus.forEach(function (subMenu) {
                subMenu.style.display = "none";
            });
        }
    }

    function addSubmenuClass(menuItems) {
        menuItems.forEach(function (li) {
            if (li.querySelector('.sub-menu')) {
                li.classList.add('has-submenu');
                addSubmenuClass(li.querySelectorAll('li'));
            } else {
                li.classList.remove('has-submenu');
            }
        });
    }

    // mobile menu functionality
    addSubmenuClass(document.querySelectorAll('.navbar .links > li'));

    let menuItems = document.querySelectorAll(".has-submenu > a");
    menuItems.forEach(item => {
        item.addEventListener("click", function (e) {
            e.preventDefault();
            let parentLi = item.parentElement;
            let subMenu = parentLi.querySelector(".sub-menu, .nested-sub-menu");

            if (subMenu) {
                let isOuterMenu = parentLi.parentElement.classList.contains('menu');

                if (subMenu.style.display === 'block') {
                    // Close the current submenu
                    subMenu.style.display = 'none';
                    item.classList.remove('open', 'current-menu-item');
                } else {
                    // If it's an outer menu, reset all other outer menu items
                    if (isOuterMenu) {
                        document.querySelectorAll(".menu > li .sub-menu, .menu > li .nested-sub-menu").forEach(menu => {
                            if (menu !== subMenu) {
                                menu.style.display = 'none';
                                let otherMenuItem = menu.closest('.has-submenu').querySelector('a');
                                if (otherMenuItem) otherMenuItem.classList.remove('open', 'current-menu-item');
                            }
                        });
                    }

                    
                    // Close other submenus within the same parent
                    parentLi.parentElement.querySelectorAll(":scope > .has-submenu > .sub-menu, :scope > .has-submenu > .nested-sub-menu").forEach(menu => {
                        if (menu !== subMenu) {
                            menu.style.display = 'none';
                            let siblingMenuItem = menu.closest('.has-submenu').querySelector('a');
                            if (siblingMenuItem) siblingMenuItem.classList.remove('open', 'current-menu-item');
                        }
                    });

                    // Open the clicked submenu
                    subMenu.style.display = 'block';
                    item.classList.add('open', 'current-menu-item');
                }
            }
        });
    });

    // Reset all classes if clicking on another outer menu item
    document.querySelectorAll(".menu > li > a").forEach(outerMenuItem => {
        outerMenuItem.addEventListener("click", function () {
            document.querySelectorAll(".menu > li > a").forEach(item => {
                if (item !== this) {
                    item.classList.remove("open", "current-menu-item");
                }
            });
        });
    });


});
// Header Js End

// Js for Tailor made forms

$(document).ready(function() {
    $('.multi-step-contact-form .container').hide();
    $('.classic-form').show();
    $('.classic-btn').click(function(){
        // $('#myContactForm')[0].reset();
        // $('.classic-form form')[0].reset();
        $('.custom-thankyou-message').remove();
        $('.fieldset-cf7mls-wrapper').show();
        // $('.fieldset-cf7mls-wrapper .fieldset-cf7mls').css('opacity', '1');
        $('.multi-step-contact-form .container').hide();
        $('.classic-form').show();
    });
    $('.tailor-btn').click(function(){
        $('.custom-thankyou-message').remove();
        $('.fieldset-cf7mls-wrapper').show();
        $('.multi-step-contact-form .container').hide();
        $('.tailor-form').show();
    });
    $('.spontaneous-btn').click(function(){
        $('.custom-thankyou-message').remove();
        $('.fieldset-cf7mls-wrapper').show();
        $('.multi-step-contact-form .container').hide();
        $('.spontaneous-form').show();
    });
    $('.intrigued-btn').click(function(){
        $('.custom-thankyou-message').remove();
        $('.fieldset-cf7mls-wrapper').show();
        $('.multi-step-contact-form .container').hide();
        $('.intrigued-form').show();
    });

    
    // Js for itenary options in forms
    $('.itinerary-options label').hover(
    function () {
        var img = $(this).find('img');
        img.attr('src', img.data('selected'));
    },
    function () {
        var img = $(this).find('img');
        img.attr('src', img.data('default'));
    }
    );
    $('.itinerary-options img').click(function(e){

        e.preventDefault();
        e.stopPropagation();

        var url = $(this).data('url');

        if(url){
            window.open(url, '_blank');
        }

    });


    jQuery(document).ready(function ($) {

        // Function to handle link click
        function handleNewTabClick() {
            $(document).on('click', '.open-new-tab', function (e) {
                e.preventDefault();
                window.open($(this).attr('href'), '_blank');
                window.focus();
            });
        }

        // Run it initially
        handleNewTabClick();

        // Re-run it after each CF7 form is loaded or submitted (in case DOM is refreshed)
        document.addEventListener('wpcf7DOMContentLoaded', handleNewTabClick);
        document.addEventListener('wpcf7submit', handleNewTabClick);
    });


    
    jQuery(document).on("click", ".cf7mls_next", function () {
        setTimeout(function () {
            new WOW().init();
        }, 500);
    });
    // document.addEventListener('wpcf7mailsent', function(event) {
    //     document.querySelector('.wpcf7-response-output').style.display = 'none'; // Hide default message
    //     document.querySelector('.custom-thank-you-message').style.display = 'block'; // Show custom message
    // }, false);

    let childrenField = $('.form-group.group-fields').eq(3); // Children field
    let childrenForm = $('.children-form');
    let childrenAges = $('.form-group.child-form'); // Ages of Children field
    // let childrenInput = $('input[name="children-field"]'); // Input for children
    // let childrenAgesInput = $('input[name="children-field-ages"]'); // Inputs for children ages
    let checkbox = $('input[name="checkbox-281[]"]'); // Checkbox

    // Hide fields initially
    childrenField.hide();
    
    childrenForm.hide();
    childrenAges.hide();
    // childrenInput.prop('required', false);
    // childrenAgesInput.prop('required', false);

    // Toggle fields and required attribute
    checkbox.change(function() {
        console.log('Checkbox clicked'); // Debugging

        if ($(this).is(':checked')) {
            childrenField.slideDown(300);
            childrenForm.slideDown(300);
            childrenAges.slideDown(300);
            // childrenInput.prop('required', true);
            // childrenAgesInput.prop('required', true);
        } else {
            childrenField.slideUp(300);
            childrenForm.slideUp(300);
            childrenAges.slideUp(300);
            // childrenInput.prop('required', false);
            // childrenAgesInput.prop('required', false);
        }
    });
});

jQuery(document).ready(function($) {
    $('input[name="first-name"]').on('input', function() {
        var firstName = $(this).get(0).value;
        console.log("First Name: " + firstName);
        localStorage.setItem('firstName', firstName);
        jQuery('.change-name').text(localStorage.getItem('firstName'));
    });
});


jQuery(document).ready(function ($) {
    // console.log('54354');
    localStorage.removeItem("storageKey"); 
    $(".form_8 input[name='trip[]']").on("change", function () {
        // console.log('2134');
        let selectedTrips = [];
        $(".form_8 input[name='trip[]']:checked").each(function () {
            selectedTrips.push($(this).val());
        });
        localStorage.setItem('storageKey', JSON.stringify(selectedTrips));
        JSON.parse(localStorage.getItem('storageKey')) || [];
        // Hide all itinerary options first
        $(".form_9 .itinerary-options").hide();
        $('.form_9 .itinerary-options.none-above').show();
        // Show only the selected itinerary categories
        selectedTrips.forEach(trip => {
            $(".form_9 .itinerary-options." + trip.toLowerCase()).show();
        });
        // If nothing is selected, hide everything
        if (selectedTrips.length === 0) {
            $(".form_9 .itinerary-options").hide();
            $('.form_9 .itinerary-options.none-above').show();
        }
    });
});

jQuery(document).ready(function($) {
    // Initial state: show coin-up
    $('.coin-up').show().addClass('coined');
    $('.coin-down').hide();

    let currentState = 'up'; // Tracks permanent state
    let hoverState = null;   // Tracks what is being hovered

    // Hover: temporarily flip the coin
    $('.coin').hover(
        function() {
            if (currentState === 'up') {
                $('.coin-up').hide();
                $('.coin-down').show();
                hoverState = 'down';
            } else {
                $('.coin-down').hide();
                $('.coin-up').show();
                hoverState = 'up';
            }
        },
        function() {
            // Restore to permanent state
            if (currentState === 'up') {
                $('.coin-down').hide();
                $('.coin-up').show();
            } else {
                $('.coin-up').hide();
                $('.coin-down').show();
            }
            hoverState = null;
        }
        );

    // Click: lock in hover state + toggle pricing-details
    $('.coin').click(function() {
        // Lock coin state based on hover
        if (hoverState === 'down') {
            currentState = 'down';
            $('.coin-up').removeClass('coined');
            $('.coin-down').addClass('coined');
            $('.coin-heading p').css('color', '#88a892');
        } else if (hoverState === 'up') {
            currentState = 'up';
            $('.coin-down').removeClass('coined');
            $('.coin-up').addClass('coined');
            $('.coin-heading p').css('color', 'revert-layer');
        }

        // Toggle pricing-details visibility
        const $details = $('.pricing-details');
        const isVisible = $details.css('display') === 'block';
        $details.css('display', isVisible ? 'none' : 'block');
        $details.toggleClass('show');
    });
});



// jQuery(document).ready(function($) {
//     jQuery('.coin').on('click', function() {
//         const $details = jQuery('.pricing-details');
//         const isVisible = $details.css('display') === 'block';
//         $details.css('display', isVisible ? 'none' : 'block');
//         $details.toggleClass('show');
//     });
// });


jQuery(document).ready(function($) {
    jQuery('.skip-btn').on('click', function() {
        console.log('click');
        jQuery(this).closest('form').children('.fieldset-cf7mls-wrapper').children('.fieldset-cf7mls').removeClass('cf7mls_current_fs');
        jQuery(this).closest('form').children('.fieldset-cf7mls-wrapper').children('.fieldset-cf7mls').first().addClass('cf7mls_current_fs');
        jQuery(this).closest('form').children('.fieldset-cf7mls-wrapper').children('.fieldset-cf7mls').removeClass('cf7mls_back_fs');
    });
    /**
     * Disable number in First name
     * 
     */

    $('.no-numbers').on('input', function () {
        this.value = this.value.replace(/[0-9]/g, '');
    });


    $('.wpcf7-phonetext').on('input', function () {
        this.value = this.value.replace(/[^0-9]/g, '');
    }); 
});


// Overlay festival and itinerary
jQuery(document).ready(function ($) {

  // Open overlay
  document.querySelectorAll('.overlay-trigger').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();

      const overlayId = this.getAttribute('data-overlay');
      const overlay = document.getElementById(overlayId);

      if (overlay) {
        overlay.style.display = 'flex';
        document.body.classList.add('no-scroll');
      }
    });
  });

  // Close overlay
  document.querySelectorAll('.overlay').forEach(overlay => {

    // Click outside content
    overlay.addEventListener('click', function (e) {
      if (!e.target.closest('.overlay-content')) {
        closeOverlay(overlay);
      }
    });

    // Click cross button (SAFE CHECK)
    const closeBtn = overlay.querySelector('.close-overlay');

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        closeOverlay(overlay);
      });
    }

  });

  // Close function
  function closeOverlay(overlay) {
    overlay.style.display = 'none';
    document.body.classList.remove('no-scroll');
  }

});

// Bhutan travel guide popup
document.addEventListener('DOMContentLoaded', function () {
  const popup = document.querySelector('[data-guide-popup]');
  const form = document.querySelector('[data-guide-popup-form]');
  const message = document.querySelector('[data-guide-popup-message]');

  if (!popup || !form || typeof bluePoppyGuidePopup === 'undefined' || sessionStorage.getItem('bluePoppyGuidePopupDismissed') === '1') {
    return;
  }

  let hasOpened = false;
  let delayTimer = window.setTimeout(openPopup, 10000);
  const nameField = form.querySelector('input[name="name"]');

  if (nameField) {
    nameField.addEventListener('input', function () {
      this.value = this.value.replace(/[0-9]/g, '');
    });
  }

  function openPopup() {
    if (hasOpened || sessionStorage.getItem('bluePoppyGuidePopupDismissed') === '1') {
      return;
    }

    hasOpened = true;
    popup.hidden = false;
    document.body.classList.add('guide-popup-open');

    const firstField = popup.querySelector('input[name="name"]');
    if (firstField) {
      window.setTimeout(function () {
        firstField.focus();
      }, 120);
    }
  }

  function closePopup() {
    sessionStorage.setItem('bluePoppyGuidePopupDismissed', '1');
    popup.hidden = true;
    document.body.classList.remove('guide-popup-open');
    window.clearTimeout(delayTimer);
  }

  document.addEventListener('mouseleave', function (event) {
    if (event.clientY <= 0) {
      openPopup();
    }
  });

  popup.querySelectorAll('[data-guide-popup-close]').forEach(function (button) {
    button.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !popup.hidden) {
      closePopup();
    }
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    if (nameField && /\d/.test(nameField.value)) {
      nameField.setCustomValidity('Please enter a valid name without numbers.');
      nameField.reportValidity();
      return;
    }

    if (nameField) {
      nameField.setCustomValidity('');
    }

    if (message) {
      message.textContent = '';
      message.classList.remove('guide-popup__message--error');
    }

    const submitButton = form.querySelector('.guide-popup__submit');
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Sending...';
    }

    fetch(bluePoppyGuidePopup.ajaxUrl, {
      method: 'POST',
      credentials: 'same-origin',
      body: new FormData(form)
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        const responseMessage = data && data.data && data.data.message
          ? data.data.message
          : 'Thank you. Please check your inbox for the guide.';

        if (!data.success) {
          throw new Error(responseMessage);
        }

        if (message) {
          message.textContent = responseMessage;
        }

        sessionStorage.setItem('bluePoppyGuidePopupDismissed', '1');
        window.setTimeout(closePopup, 2400);
      })
      .catch(function (error) {
        if (message) {
          message.textContent = error.message || 'We could not send the guide just now. Please try again.';
          message.classList.add('guide-popup__message--error');
        }
      })
      .finally(function () {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = 'Send me the guide';
        }
      });
  });
});

// Cookie consent banner
document.addEventListener('DOMContentLoaded', function () {
  const banner = document.querySelector('[data-cookie-banner]');
  const cookieName = 'blue_poppy_cookie_consent';

  if (!banner || getCookie(cookieName)) {
    return;
  }

  banner.hidden = false;

  banner.querySelectorAll('[data-cookie-choice]').forEach(function (button) {
    button.addEventListener('click', function () {
      const choice = button.getAttribute('data-cookie-choice') === 'all' ? 'all' : 'essential';

      setCookie(cookieName, choice, 180);
      banner.hidden = true;
      document.dispatchEvent(new CustomEvent('bluePoppyCookieConsentUpdated', {
        detail: {
          consent: choice
        }
      }));
    });
  });

  function getCookie(name) {
    return document.cookie
      .split('; ')
      .find(function (row) {
        return row.indexOf(name + '=') === 0;
      });
  }

  function setCookie(name, value, days) {
    const maxAge = days * 24 * 60 * 60;
    document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
  }
});

// Footer newsletter signup
document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('[data-footer-signup-form]');
  const message = document.querySelector('[data-footer-signup-message]');

  if (!form || !message || typeof bluePoppyGuidePopup === 'undefined') {
    return;
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    message.textContent = '';
    message.classList.remove('footer-signup__message--error');

    const submitButton = form.querySelector('.footer-signup__button');
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Subscribing...';
    }

    fetch(bluePoppyGuidePopup.ajaxUrl, {
      method: 'POST',
      credentials: 'same-origin',
      body: new FormData(form)
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        const responseMessage = data && data.data && data.data.message
          ? data.data.message
          : 'Thank you for your interest. We will be in touch with the next edition when it is ready.';

        if (!data.success) {
          throw new Error(responseMessage);
        }

        form.reset();
        message.textContent = responseMessage;
      })
      .catch(function (error) {
        message.textContent = error.message || 'We could not save your subscription just now. Please try again.';
        message.classList.add('footer-signup__message--error');
      })
      .finally(function () {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = 'Subscribe';
        }
      });
  });
});


// jQuery(document).on('click', '.cf7mls_next', function(event) {
//     // alert('1234');
//     var jQuerynextButton = jQuery(this);
//     var jQueryform = jQuerynextButton.closest('form');
//     var jQuerycurrentStep = jQueryform.find('.cf7mls_current_fs');

//     if (jQuerycurrentStep.length === 0) return;

//     // Delay to allow CF7 to insert validation messages
//     setTimeout(function() {
//         var jQueryhasFieldErrors = jQuerycurrentStep.find('.wpcf7-not-valid-tip');
//         var jQueryvalidationErrorBlock = jQuerycurrentStep.find('.wpcf7-validation-errors');
//         console.log(jQueryhasFieldErrors.length)
//         if (jQueryhasFieldErrors.length > 0 && jQueryvalidationErrorBlock.length > 0) {
//             jQueryvalidationErrorBlock.hide();
//             // jQueryhasFieldErrors.hide();
//             // jQueryvalidationErrorBlock.text('Please fill out the above field.');

//         }
//     }, 500); // Delay long enough for CF7 to render errors
// });
